<template lang="pug">
    div.hidden

        // main
        el-form-item(prop="title")
        el-form-item(prop="key")

        // settings
        el-form-item(prop="created_at")
        el-form-item(prop="view")
        el-form-item(prop="category")
</template>

<script>

import _ from 'lodash'

export default {
    name: 'AllInputFields',
}
</script>
